// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3IsBS","rootCenter":"LoadMoreObserver_rootCenter__2o_dF","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__AkuYe"};